import { ChangeDetectorRef, Directive } from '@angular/core';
import { Observable } from 'rxjs';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { TicketAttachmentType } from '@shared/enums/attachment-type';
import { DashboardMode } from '@shared/enums/dashboard-mode';
import { DashboardViewType } from '@shared/enums/dashboard-view-type';
import { PermissionLevelType } from '@shared/enums/permission-level.enum';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { EnumerationConfig } from '@shared/interfaces/enumeration-config';

@Directive()
export abstract class DashboardsAbstract extends ComponentAbstract {
  emptyDashboard = true;

  selectSelectedPropertyId$: Observable<number>;
  selectSelectedPortfolioId$: Observable<number>;
  enumerations$: Observable<EnumerationConfig>;

  dashboardMode: DashboardMode;
  dashboardMode$: Observable<DashboardMode>;
  permissionList: PermissionLevelType[];
  permissionsList$: Observable<PermissionLevelType[]>;

  protected constructor(protected cdr: ChangeDetectorRef) {
    super(cdr);
  }

  get WorkflowStep(): typeof WorkflowStepEnumType {
    return WorkflowStepEnumType;
  }

  get DashboardViewType(): typeof DashboardViewType {
    return DashboardViewType;
  }

  get DashboardMode(): typeof DashboardMode {
    return DashboardMode;
  }

  get TicketAttachmentType(): typeof TicketAttachmentType {
    return TicketAttachmentType;
  }
}
